import { BaseDto } from './base.dto';

export class SpecialProductDto extends BaseDto {
  specialId: number;
  productId: number;
}
